import Reveal from '@/components/base/Reveal';
import { plotLine } from '@/mocks/comicData';

export default function Storyline() {
  return (
    <section id="story" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              剧情主线
              <span className="h-px w-8 bg-primary-500" />
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black md:text-4xl">从一盏灯亮起，到一段执念放下</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              洞洞杂货铺漫画的剧情由浅入深：以单元故事铺陈世界观，再逐步收紧到店长身世与三十年约定的主线。按下面的脉络，几分钟就能看懂全剧结构。
            </p>
          </div>
        </Reveal>

        <div className="relative mx-auto mt-12 max-w-3xl">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-primary-300 via-accent-300 to-secondary-300 md:left-1/2" />
          <div className="flex flex-col gap-8">
            {plotLine.map((item, i) => (
              <Reveal key={item.step} delay={i * 80}>
                <div className="relative flex flex-col gap-4 pl-14 md:w-1/2 md:pl-0">
                  {i % 2 === 0 ? (
                    <>
                      <div className="hidden md:block" />
                      <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 shadow-sm md:mr-8 md:text-right">
                        <div className="flex items-center gap-2 md:justify-end">
                          <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                            {item.step}
                          </span>
                        </div>
                        <h3 className="mt-3 font-heading text-lg font-bold">{item.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.text}</p>
                      </div>
                    </>
                  ) : (
                    <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 shadow-sm md:ml-8">
                      <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
                        {item.step}
                      </span>
                      <h3 className="mt-3 font-heading text-lg font-bold">{item.title}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.text}</p>
                    </div>
                  )}
                  <span className="absolute left-[11px] top-5 flex h-4 w-4 items-center justify-center rounded-full bg-background-50 ring-4 ring-primary-400 md:left-auto md:top-6 md:h-4 md:w-4 md:ring-4">
                    <span className="h-2 w-2 rounded-full bg-accent-500" />
                  </span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}